module.exports = __webpack_public_path__ + "static/img/loveshop4b9e29f.png";